import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=4a6121a0&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=4a6121a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6121a0",
  null
  
)

export default component.exports